import { useEffect } from "react";
import { PrimaryButton } from "common/PrimaryButton";

import * as S from "./styled";

export const Modal = ({
  isModalOpen,
  title,
  description,
  successButtonText,
  cancelButtonText,
  onSuccess,
  onCancel,
  successLoadingStatus,
  className,
  contentClassName,
  children,
  showCloseButton = false,
  closeOnEscape = false,
  closeOnBackdropClick = false,
}) => {
  // Lock background scroll while the modal is open so the page can't scroll behind it.
  useEffect(() => {
    if (!isModalOpen) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previous;
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (!isModalOpen || !closeOnEscape) return undefined;

    const onKeyDown = (event) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      onCancel?.();
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isModalOpen, closeOnEscape, onCancel]);

  return (
    <>
      {isModalOpen ? (
        <S.Modal
          className={className}
          onMouseDown={(event) => {
            if (closeOnBackdropClick && event.target === event.currentTarget) onCancel?.();
          }}
        >
          <S.ModalContent className={contentClassName}>
            {showCloseButton ? (
              <button
                aria-label="Close"
                className="absolute right-3 top-3 flex h-7 w-7 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600"
                type="button"
                onClick={onCancel}
              >
                <svg
                  fill="none"
                  height={14}
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeWidth={2}
                  viewBox="0 0 24 24"
                  width={14}
                >
                  <path d="M18 6 6 18M6 6l12 12" />
                </svg>
              </button>
            ) : null}
            {title ? <S.Heading>{title}</S.Heading> : null}
            {description ? <S.Text>{description}</S.Text> : null}
            {children}
            {successButtonText || cancelButtonText ? (
              <S.ConfirmContent>
                {successButtonText ? (
                  <PrimaryButton eventHandler={onSuccess} label={successButtonText} loading={successLoadingStatus} />
                ) : null}
                {cancelButtonText ? (
                  <PrimaryButton eventHandler={onCancel} label={cancelButtonText} mode="gray" />
                ) : null}
              </S.ConfirmContent>
            ) : null}
          </S.ModalContent>
        </S.Modal>
      ) : null}
    </>
  );
};
